// Cabeçalho com saudação, unidade, caixa e hora.
import React from "react";
import * as Styles from "../../styles/PointOfSale.styles";

export const RotuloDoPeriodo: React.FC<{
  component: any;
  componentProps: any;
  subsidiaryDataZustand: any;
  authUserZustand: any;
  currentDate: string;
  greetingMessage: string;
}> = ({
  component,
  componentProps,
  subsidiaryDataZustand,
  authUserZustand,
  currentDate,
  greetingMessage,
}) => {
  return (
    <Styles.PeriodInfoContainer
      selected={Boolean(component.componentSelected)}
      id={String(component.componentId)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentStatus={String(componentProps.componentStatus)}
      componentColor={String(componentProps.componentColor)}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <Styles.PeriodInfoLabel infoAlign="left">
        {greetingMessage}
      </Styles.PeriodInfoLabel>
      <Styles.PeriodInfoLabel infoAlign="right">
        {String(currentDate)}
      </Styles.PeriodInfoLabel>
      <Styles.PeriodInfoLabel infoAlign="left">
        {authUserZustand?.userInfo.userSocialName}
      </Styles.PeriodInfoLabel>
      <Styles.PeriodInfoLabel infoAlign="right">
        {new Date().toLocaleTimeString("pt-BR")}
      </Styles.PeriodInfoLabel>
      <Styles.PeriodInfoLabel infoAlign="left">
        {subsidiaryDataZustand.selectedPdv.itemName}
      </Styles.PeriodInfoLabel>
      <Styles.PeriodInfoLabel infoAlign="right">
        {
          subsidiaryDataZustand.selectedPdv.selectedPeriod
            ?.periodTypeUuid.periodTypeName
        }
      </Styles.PeriodInfoLabel>
    </Styles.PeriodInfoContainer>
  );
};
